import { contextFactory } from '@frontend/design-system';
import { UseWritebackAuthResults } from './useWritebackAuth';

export const [DigitalFormsWritebackAuthContext, useDigitalFormsWritebackAuthContext] =
  contextFactory<UseWritebackAuthResults>(
    'useDigitalFormsWritebackAuthContext must be used within a DigitalFormsWritebackAuthContext'
  );
